import {useQueryClient} from "@tanstack/react-query";
import {useCallback} from "preact/hooks";

const useClearQueries = () => {
  const queryClient = useQueryClient()
  return useCallback(() => queryClient.clear(), [queryClient])
}

export default useClearQueries
